var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "siteDetail" } },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "100vh",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
            },
            [
              _c(
                "div",
                [
                  _c("md-progress-spinner", {
                    staticClass: "md-accent text-light",
                    attrs: { "md-diameter": 30, "md-mode": "indeterminate" },
                  }),
                ],
                1
              ),
            ]
          )
        : _c("div", [
            _c(
              "div",
              {
                staticClass: "header",
                staticStyle: { height: "75px", background: "#031529" },
              },
              [
                _c("span", [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.siteAddress") +
                          " : " +
                          _vm.site.siteAddress
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.createdDate")) +
                        " : " +
                        _vm._s(_vm.createdTime()) +
                        "\n                "
                    ),
                    _c(
                      "a-button",
                      {
                        staticClass: "bg-dark border-dark text-light",
                        on: {
                          click: function ($event) {
                            return _vm.edit(_vm.site._id)
                          },
                        },
                      },
                      [_c("ActionEdit")],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                {
                  staticClass: "left",
                  staticStyle: {
                    width: "15%",
                    background: "#1e1e2d !important",
                  },
                },
                [
                  _c(
                    "a-menu",
                    {
                      staticClass: "h-100 w-100",
                      attrs: {
                        "default-selected-keys": _vm.selectedPage,
                        mode: "vertical",
                        theme: "dark",
                      },
                      model: {
                        value: _vm.selectedPage,
                        callback: function ($$v) {
                          _vm.selectedPage = $$v
                        },
                        expression: "selectedPage",
                      },
                    },
                    [
                      _c(
                        "a-menu-item",
                        { key: "dashboard" },
                        [
                          _c("a-icon", { attrs: { type: "dashboard" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Dashboard")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "agents" },
                        [
                          _c("a-icon", { attrs: { type: "customer-service" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Agents")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "integration" },
                        [
                          _c("a-icon", {
                            attrs: { type: "safety-certificate" },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Integration")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "settings" },
                        [
                          _c("a-icon", { attrs: { type: "setting" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Settings")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "contacts" },
                        [
                          _c("a-icon", { attrs: { type: "link" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Contacts")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "invoices" },
                        [
                          _c("a-icon", { attrs: { type: "gold" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.invoices")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right", staticStyle: { width: "85%" } },
                [
                  _c("a-card", [
                    _vm.selectedPage.includes("dashboard")
                      ? _c(
                          "div",
                          [
                            _c("div", { staticClass: "box-container" }, [
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.Agents"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.site.agentCount) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.Domain"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.site.integratedOrigins.length)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.lastActivity"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.lastActivity())),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(_vm.$t("billing.basePrice"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(_vm.site.basePrice.value) +
                                        " " +
                                        _vm._s(_vm.site.basePrice.currency)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: { click: _vm.showBasePricePrompt },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.packagePrice"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.calculateAgentPrice(
                                          _vm.site.settings.plan.detail
                                            .maxAgentCount
                                        )
                                      ) +
                                      "\n                                    (" +
                                      _vm._s(_vm.$t("billing.discount")) +
                                      ": % " +
                                      _vm._s(
                                        _vm.site.basePrice.discount * 100
                                      ) +
                                      ")\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("billing.whatsappPrice"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.site,
                                            "whatsappBasePrice.value",
                                            0
                                          )
                                        ) +
                                        "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.site,
                                            "whatsappBasePrice.currency"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click: _vm.showWhatsappPricePrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.Integration"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _vm.site.isIntegrated
                                      ? _c("a-icon", {
                                          staticStyle: { color: "green" },
                                          attrs: { type: "check-circle" },
                                        })
                                      : _c("a-icon", {
                                          staticStyle: { color: "red" },
                                          attrs: { type: "close-circle" },
                                        }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("billing.realtimeVisitorCount")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.site.realtimeVisitorCount)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.suspend"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "md-switch",
                                      {
                                        staticClass: "md-primary",
                                        model: {
                                          value: _vm.suspend,
                                          callback: function ($$v) {
                                            _vm.suspend = $$v
                                          },
                                          expression: "suspend",
                                        },
                                      },
                                      [
                                        _vm.site.suspend
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.active"))
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.passive")
                                                )
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.partner"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.$_.get(_vm.site, "partner.name"))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.plan"))),
                                ]),
                                _vm._v(" "),
                                _vm.site.settings.plan
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.site.settings.plan.selectedPlan.toUpperCase()
                                          ) +
                                          "(" +
                                          _vm._s(
                                            _vm.site.settings.plan.detail
                                              .maxAgentCount
                                          ) +
                                          "\n                                    Agent)\n                                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(_vm.$t("billing.trialDay"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.trialDay) +
                                        " - " +
                                        _vm._s(_vm.$t("billing.trialDay"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(_vm.getRemainingTrialDay()) +
                                        " - " +
                                        _vm._s(_vm.$t("billing.daysLeft"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: { click: _vm.showTrialPrompt },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "new-line-box",
                                  staticStyle: { height: "max-content" },
                                },
                                [
                                  _c(
                                    "div",
                                    { attrs: { id: "chart" } },
                                    [
                                      _c(
                                        "ECharts",
                                        {
                                          ref: "chart",
                                          staticStyle: {
                                            height: "calc(100vh - 200px)",
                                          },
                                          attrs: {
                                            id: "chart-2",
                                            option: _vm.line,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.drawLineChart) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.mobile"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _vm.site.mobileUserCount > 0
                                      ? _c("a-icon", {
                                          staticStyle: { color: "green" },
                                          attrs: { type: "check-circle" },
                                        })
                                      : _c("a-icon", {
                                          staticStyle: { color: "red" },
                                          attrs: { type: "close-circle" },
                                        }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.webSite"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "text-decoration": "underline",
                                      },
                                      attrs: {
                                        href:
                                          (_vm.IS_DEV_ENVIRONMENT
                                            ? "http"
                                            : "https") +
                                          "://" +
                                          _vm.site.settings.website,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("a-icon", { attrs: { type: "link" } }),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.site.settings.website)
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.websiteOrigins"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  _vm._l(
                                    _vm.site.integratedOrigins,
                                    function (dom) {
                                      return _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "200px",
                                            padding: "3px",
                                          },
                                          attrs: { value: dom },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                "text-decoration": "underline",
                                              },
                                              attrs: {
                                                href:
                                                  (_vm.IS_DEV_ENVIRONMENT
                                                    ? "http"
                                                    : "https") +
                                                  "://" +
                                                  dom,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c("a-icon", {
                                                attrs: { type: "link" },
                                              }),
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(dom) +
                                                  "\n                                        "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticClass: "bg-danger border-dark text-light",
                                on: {
                                  click: function ($event) {
                                    return _vm.del(_vm.site._id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mr-1",
                                    staticStyle: {
                                      "font-size": "1.5rem",
                                      "font-weight": "bold",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("message.deleteSite")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedPage.includes("agents")
                      ? _c(
                          "div",
                          [
                            _c("UserList", {
                              attrs: { "site-id": _vm.site._id },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedPage.includes("integration")
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("message.integration"))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedPage.includes("settings")
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("message.setting")))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedPage.includes("invoices")
                      ? _c(
                          "div",
                          [
                            _c("InvoiceList", {
                              attrs: {
                                "initial-data": _vm.site,
                                "site-address": _vm.site.clientAddress,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedPage.includes("contacts")
                      ? _c("div", [
                          _c("div", { staticClass: "box-container" }, [
                            _c("div", { staticClass: "box" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(_vm._s(_vm.$t("billing.ownerName"))),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.site.rootUserName) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "box" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("billing.ownerEmailAddress"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.site.rootUserEmail) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]),
          ]),
      _vm._v(" "),
      _c("SiteCreateModalForm", {
        attrs: {
          "edit-mode": true,
          "on-cancel": _vm.onModalFormCancel,
          "on-success": _vm.onModalFormSuccess,
          "updating-site": _vm.updatingSite,
          visible: _vm.modalVisible,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }